import { render, staticRenderFns } from "./LiveMain.vue?vue&type=template&id=5197ec01&scoped=true&"
import script from "./LiveMain.vue?vue&type=script&lang=js&"
export * from "./LiveMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197ec01",
  null
  
)

export default component.exports